import { Center } from "./center.model";

export class User {
  public email: string;
  public name: string;
  public lastName: string;
  public isMarketingAllowed: boolean;
  public isDemo: boolean;
  public acceptedTermsVersion: number;
  public acceptedPrivacyPolicyVersion: number;
  public isStaff: boolean;
  public centerAdmin: boolean;
  public center: Center;
  public token: string;
  public pendingLegalAcceptances: Array<{documentType: string; version: number}>;

  constructor(
    email: string,
    name: string,
    lastName: string,
    isMarketingAllowed: boolean,
    isDemo: boolean,
    acceptedTermsVersion: number,
    acceptedPrivacyPolicyVersion: number,
    center: Center,
    token: string,
    isStaff = false,
    pendingLegalAcceptances: Array<{documentType: string; version: number}> = [],
    centerAdmin = false,
  ) {
    this.email = email;
    this.name = name;
    this.lastName = lastName;
    this.isMarketingAllowed = isMarketingAllowed;
    this.isDemo = isDemo;
    this.acceptedTermsVersion = acceptedTermsVersion;
    this.acceptedPrivacyPolicyVersion = acceptedPrivacyPolicyVersion;
    this.isStaff = isStaff;
    this.centerAdmin = centerAdmin;
    this.center = center;
    this.token = token;
    this.pendingLegalAcceptances = pendingLegalAcceptances;
  }
}
